import { Images } from "../../Assets/Index";
import { useSelector } from "react-redux";
import { dispatchtoast, getLocalStorageItem } from "../../Utils";
import {
  Button,
  Checkbox,
  Drawer,
  Input,
  InputNumber,
  Space,
  Table,
  Tabs,
} from "antd";
import { IoCaretBack } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import ColumnGroup from "antd/es/table/ColumnGroup";
import Column from "antd/es/table/Column";
import { placebet } from "./HomeApi";
import { useCommmonStore } from "../../Store/CommonReducer";
import { getProfile } from "../Profile/UserEndpoints";
const LiveGames = () => {
  const walletBalance = useSelector((state) => state.colorGame.walletBal);
  const withdrawAmount = useSelector((state) => state.colorGame.withdrawAmt);
  const navigate = useNavigate();
  const [activeKey, setactivekey] = useState("1");
  const [openBet, setOpenBet] = useState(false);
  const [bidAmount, setBidAmount] = useState(0);
  const [betData, setBetData] = useState("");
  const [bidType, setBidType] = useState("");
  const [bidValue, setBidValue] = useState("");
  const [withPalti, setWithPalti] = useState(false);
  const [withJoda, setWithJoda] = useState(false);
  const [crossingBids, setCrossingBids] = useState([]);
  const [bidAmountAndar, setBidAmountAndar] = useState(0);

  const [bidAmountBahar, setBidAmountBahar] = useState(0);

  const location = useLocation();
  const fill = location?.state.fill;
  const { profileDetail, setProfileDetail } = useCommmonStore();

  const [dataSource, setDataSource] = useState([
    {
      A: "A0",
      AndarAmount: "₹",
      B: "B0",
      BaharAmount: "₹",
    },
    {
      A: "A1",
      AndarAmount: "₹",
      B: "B1",
      BaharAmount: "₹",
    },
    {
      A: "A2",
      AndarAmount: "₹",
      B: "B2",
      BaharAmount: "₹",
    },
    {
      A: "A3",
      AndarAmount: "₹",
      B: "B3",
      BaharAmount: "₹",
    },
    {
      A: "A4",
      AndarAmount: "₹",
      B: "B4",
      BaharAmount: "₹",
    },
    {
      A: "A5",
      AndarAmount: "₹",
      B: "B5",
      BaharAmount: "₹",
    },
    {
      A: "A6",
      AndarAmount: "₹",
      B: "B6",
      BaharAmount: "₹",
    },
    {
      A: "A7",
      AndarAmount: "₹",
      B: "B7",
      BaharAmount: "₹",
    },
    {
      A: "A8",
      AndarAmount: "₹",
      B: "B8",
      BaharAmount: "₹",
    },
    {
      A: "A9",
      AndarAmount: "₹",
      B: "B9",
      BaharAmount: "₹",
    },
  ]);

  const onChange = (key) => {
    console.log(key);
  };

  const placeBidForJodi = () => {
    const originalValue = bidValue.toString().padStart(2, "0");
    const paltiValue = originalValue.split("").reverse().join("");

    const betNumbers = withPalti
      ? [
          { type: "jodi", value: Number(originalValue), betAmount: bidAmount },
          { type: "jodi", value: Number(paltiValue), betAmount: bidAmount },
        ]
      : [{ type: bidType, value: bidValue, betAmount: bidAmount }];

    const payload = {
      betNumber: betNumbers,
      // betAmount: withPalti ? bidAmount * 2 : bidAmount,
      room: fill?.room_id,
      game_slug: fill?.room_game_slug,
    };

    placebet(payload).then((res) => {
      if (res.status) {
        console.log(res);
        dispatchtoast(res.message, false);
        getProfile()
          .then((res) => {
            if (res.status) {
              setProfileDetail(res.data);
            }
          })
          .catch((err) => console.log(err));
      }
    });
  };
  const placeBidForCrossing = () => {
    const betNumber = crossingBids.map(({ type, value, betAmount }) => ({
      type,
      value,
      betAmount: Number(bidAmount),
    }));
    const finalBetAmount = crossingBids.length * Number(bidAmount);

    const payload = {
      betNumber,
      // betAmount: finalBetAmount,
      room: fill?.room_id,
      game_slug: fill?.room_game_slug,
    };

    placebet(payload).then((res) => {
      if (res.status) {
        console.log(res);
        dispatchtoast(res.message, false);
        getProfile()
          .then((res) => {
            if (res.status) {
              setProfileDetail(res.data);
            }
          })
          .catch((err) => console.log(err));
      }
    });
  };

  const placeBidForHaroof = () => {
    const betNumber = [];

    dataSource.forEach((row) => {
      if (row.AndarAmount > 0) {
        betNumber.push({
          type: "haruf",
          value: row.A,
          betAmount: row.AndarAmount,
        });
      }
      if (row.BaharAmount > 0) {
        betNumber.push({
          type: "haruf",
          value: row.B,
          betAmount: row.BaharAmount,
        });
      }
    });

    const payload = {
      betNumber,
      room: fill?.room_id,
      game_slug: fill?.room_game_slug,
    };

    placebet(payload).then((res) => {
      if (res.status) {
        dispatchtoast(res.message, false);
        getProfile()
          .then((res) => {
            if (res.status) setProfileDetail(res.data);
          })
          .catch((err) => console.log(err));
      }
    });
  };

  const handleTabChange = (key) => {
    console.log(bidAmountAndar, "crossingbid");
    setBidAmount(0);
    setBidValue("");
    setBidAmountAndar(0);
    setBidAmountBahar(0);
    setWithPalti(false);
    setWithJoda(false);
    setBidType(
      key === 1 ? "jodi" : key === 2 ? "crossing" : key === 3 ? "haruf" : ""
    );
  };

  return (
    <>
      <div className="flex justify-center pb-20 items-center bg-black rounded-lg">
        <div className="w-full ">
          <div className="flex justify-between bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f] px-8  py-2 gap-x-3 items-center ">
            <div className="text-white font-semibold flex  items-center gap-4 ">
              <IoCaretBack
                className="bg-[#ba7d13] h-7 w-7 rounded-lg cursor-pointer text-white"
                onClick={() => navigate("/home")}
              />
              <p className="text-xl font-normal custome">
                {/* {getLocalStorageItem("userDetails")?.name}My Profile */}
                Live Games
              </p>
            </div>
            <div className="flex justify-between items-center">
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-white text-sm  custome">
                ₹ {profileDetail?.user?.wallet_balance ?? 0}
              </p>
            </div>
          </div>
          <div className="overflow-y-scroll">
            {" "}
            <div className="">
              <Tabs
                centered
                onChange={(key) => handleTabChange(key)}
                // activeKey={activeKey}
                defaultActiveKey="1"
                items={[
                  {
                    key: "1",
                    label: <p className="text-white text-base custome">JODI</p>,
                    children: (
                      <>
                        <div
                          className="text-white text-base grid grid-cols-5 m-4 gap-2 custome h-screen"
                          style={{
                            marginBottom: "100px",
                            overflowY: "auto",
                          }}
                        >
                          {Array.from({ length: 99 }, (_, i) => i + 1).map(
                            (i) => {
                              const current = i.toString().padStart(2, "0");
                              const selected = bidValue
                                ?.toString()
                                .padStart(2, "0");
                              const isSelected =
                                selected === current ||
                                (withPalti &&
                                  selected?.split("").reverse().join("") ===
                                    current);

                              return (
                                <p
                                  key={i}
                                  className="text-white text-base text-center bg-gray-400 p-4 rounded-md cursor-pointer"
                                  onClick={() => {
                                    setOpenBet(true);
                                    setBidValue(i);
                                    setBidAmount(0);
                                    setBidType("jodi");
                                    setWithPalti(false); // Reset palti toggle when a new number is selected (optional)
                                  }}
                                >
                                  {current}
                                  {isSelected && bidAmount ? (
                                    <p className="grid text-[#734e0c] font-bold">
                                      ₹{bidAmount}
                                    </p>
                                  ) : null}
                                </p>
                              );
                            }
                          )}
                        </div>
                        {openBet && (
                          <Drawer
                            title="Enter Bid Amount"
                            placement="bottom"
                            closable={false}
                            onClose={() => setOpenBet(false)}
                            open={openBet}
                            extra={
                              <Space>
                                <Button
                                  disabled={bidAmount === 0}
                                  type="default"
                                  onClick={() => {
                                    setOpenBet(false);
                                    setBidType("jodi");
                                  }}
                                  className="mt-8 custome rounded-3xl h-8  font-medium text-lg border-none
                              text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
                              hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
                                >
                                  Place Bid
                                </Button>
                              </Space>
                            }
                          >
                            <InputNumber
                              placeholder="Set Bet"
                              className="mt-2 w-full"
                              value={bidAmount}
                              onChange={(e) => setBidAmount(e)}
                            />
                            <Checkbox
                              className="mt-10 text-white"
                              onChange={(e) => setWithPalti(e.target.checked)}
                            >
                              With Palti
                            </Checkbox>
                          </Drawer>
                        )}
                      </>
                    ),
                  },
                  {
                    key: "2",
                    label: (
                      <p className="text-white text-base custome">CROSSING</p>
                    ),
                    children: (
                      <div className="h-screen">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-white text-base m-4 custome">
                          {" "}
                          <Input
                            type="number"
                            max={99}
                            min={10}
                            className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                            placeholder="Enter two digit number"
                            onKeyDown={(e) => {
                              const allowedKeys = [
                                "Backspace",
                                "Tab",
                                "ArrowLeft",
                                "ArrowRight",
                                "Delete",
                              ];
                              if (allowedKeys.includes(e.key)) return;

                              if (!/^\d$/.test(e.key)) {
                                e.preventDefault();
                                return;
                              }
                              const num = parseInt(e.key, 9);
                              if (num === 0) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              const val = e.target.value;
                              setBidValue(val);
                              setBidType("crossing");

                              if (val.length === 2 && /^\d{2}$/.test(val)) {
                                const [a, b] = val.split("");

                                const combinations = withJoda
                                  ? [
                                      `${a}${b}`,
                                      `${b}${a}`,
                                      `${a}${a}`,
                                      `${b}${b}`,
                                    ]
                                  : [val];

                                const formattedBids = combinations.map(
                                  (value) => ({
                                    type: "crossing",
                                    value,
                                    betAmount: Number(bidAmount),
                                  })
                                );

                                setCrossingBids(formattedBids);
                              } else {
                                setCrossingBids([]);
                              }
                            }}
                          />
                          <Input
                            className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                            placeholder="₹ Max 5000"
                            onChange={(e) => {
                              const val = e.target.value;
                              setBidAmount(val);
                              setBidType("crossing");

                              setCrossingBids((prev) =>
                                prev.map((item) => ({
                                  ...item,
                                  amount: Number(val),
                                }))
                              );
                            }}
                          />
                        </div>
                        <Checkbox
                          className="m-4 text-white custome"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setWithJoda(checked);

                            if (
                              bidValue.length === 2 &&
                              /^\d{2}$/.test(bidValue)
                            ) {
                              const [a, b] = bidValue.split("");

                              const combinations = checked
                                ? [
                                    `${a}${b}`,
                                    `${b}${a}`,
                                    `${a}${a}`,
                                    `${b}${b}`,
                                  ]
                                : [bidValue];

                              const formattedBids = combinations.map(
                                (value) => ({
                                  type: "crossing",
                                  value,
                                  amount: Number(bidAmount),
                                })
                              );

                              setCrossingBids(formattedBids);
                            }
                          }}
                        >
                          With Joda
                        </Checkbox>

                        <div className="">
                          <p className="custome text-white text-sm p-5 text-center">
                            Crossing Numbers
                          </p>
                          <div className="flex justify-center">
                            {" "}
                            <table className="w-1/2 text-white text-sm font-dmsans border-collapse">
                              <thead>
                                <tr className="custome bottom-4">
                                  <th className="p-2 text-center text-[#e9a52f]">
                                    Number
                                  </th>
                                  <th className="p-2 text-center text-[#e9a52f]">
                                    Amount
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {crossingBids.map((bid, index) => (
                                  <tr
                                    key={index}
                                    className="border-t border-gray-600"
                                  >
                                    <td className="p-2 text-center">
                                      {bid.value}
                                    </td>
                                    <td className="p-2 text-center">
                                      ₹{bid.amount ?? bidAmount}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    ),
                  },
                  {
                    key: "3",
                    label: (
                      <p className="text-white text-base custome">HAROOF</p>
                    ),
                    children: (
                      <div className=" flex text-center justify-center">
                        <Table
                          rowHoverable={false}
                          className="h-screen cursor-pointer"
                          dataSource={dataSource}
                          pagination={false}
                          rowClassName={() => "editable-row"}
                          style={{
                            marginBottom: "100px",
                            overflowY: "auto",
                          }}
                        >
                          <ColumnGroup title="Andar">
                            <Column
                              title="Andar"
                              dataIndex="A"
                              key="A"
                              render={(text, record, index) => (
                                <p
                                  className="cursor-pointer"
                                  onClick={() => {
                                    console.log("Clicked:", text, index);
                                    setBidType("haruf");
                                  }}
                                >
                                  {text}
                                </p>
                              )}
                            />
                            <Column
                              title="Amount"
                              dataIndex="AndarAmount"
                              key="AndarAmount"
                              render={(text, record, index) => {
                                return (
                                  <Input
                                    value={dataSource[index].AndarAmount}
                                    onChange={(e) => {
                                      const value = Number(e.target.value);
                                      const updated = [...dataSource];
                                      updated[index].AndarAmount = value;
                                      setDataSource(updated);
                                      setBidAmountAndar(e.target.value);
                                      setBidValue(record?.A);
                                      setBidType("haruf");
                                    }}
                                    max={9}
                                    min={1}
                                    type="number"
                                    className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-md border-none"
                                  />
                                );
                              }}
                            />
                          </ColumnGroup>
                          <ColumnGroup title="Bahar">
                            <Column title="Bahar" dataIndex="B" key="B" />
                            <Column
                              title="Amount"
                              dataIndex="BaharAmount"
                              key="BaharAmount"
                              render={(text, record, index) => {
                                return (
                                  <Input
                                    value={dataSource[index].BaharAmount}
                                    onChange={(e) => {
                                      const value = Number(e.target.value);
                                      const updated = [...dataSource];
                                      updated[index].BaharAmount = value;
                                      setDataSource(updated);
                                      setBidAmountBahar(e.target.value);
                                      setBidValue(record?.B);
                                      setBidType("haruf");
                                    }}
                                    max={9}
                                    min={1}
                                    type="number"
                                    className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-md border-none"
                                  />
                                );
                              }}
                            />
                          </ColumnGroup>
                        </Table>
                      </div>
                    ),
                  },
                ]}
                // onChange={onChange}
              />
              <div
                className="flex w-[432px] sm:w-[480px] m-auto bg-black
                   text-white fixed bottom-20 left-0 right-0  justify-around py-2  items-center"
              >
                <div className="custome">
                  <p>Total Amount</p>
                  <p>
                    ₹{" "}
                    {bidType === "jodi"
                      ? withPalti
                        ? bidAmount * 2
                        : bidAmount
                      : bidType === "crossing"
                      ? withJoda
                        ? crossingBids.length * Number(bidAmount)
                        : bidAmount
                      : dataSource.reduce((sum, row) => {
                          const andar = parseFloat(row.AndarAmount);
                          const bahar = parseFloat(row.BaharAmount);
                          return (
                            sum +
                            (isNaN(andar) ? 0 : andar) +
                            (isNaN(bahar) ? 0 : bahar)
                          );
                        }, 0)}
                  </p>
                </div>
                <Button
                  disabled={
                    bidType === "jodi" || bidType === "crossing"
                      ? bidAmount === 0
                        ? true
                        : bidType === "haruf"
                      : Number(bidAmountAndar) === 0 ||
                        Number(bidAmountBahar) === 0
                  }
                  type="default"
                  className="mt-8 custome rounded-3xl h-8  font-medium text-lg border-none
                   text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
                   hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
                  onClick={
                    bidType === "jodi"
                      ? placeBidForJodi
                      : bidType === "crossing"
                      ? placeBidForCrossing
                      : placeBidForHaroof
                  }
                >
                  Place Bid
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LiveGames;
